import { Flex, FormLabel } from '@chakra-ui/react';
import React from 'react';
import { DoneIcon, Locale } from '../../shared';
import translation from './lib/translations';

interface IKeyFeaturesProps {
  locale: Locale | string;
}

const KeyFeatures: React.FC<IKeyFeaturesProps> = ({ locale }) => {
  const { benefits } = translation(locale);

  return (
    <Flex flexDir='column'>
      <FormLabel>{benefits.heading}</FormLabel>
      <Flex
        flexDir='column'
        gap='sm'
      >
        {benefits.features.map((feature) => (
          <Flex
            key={feature}
            gap='sm'
          >
            <DoneIcon
              mt='3px'
              boxSize={5}
              color='primary.pure'
            />
            {feature}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default KeyFeatures;
